import {
    Component,
    ChangeDetectionStrategy,
    Input,
    EventEmitter,
    Output,
    OnChanges,
    SimpleChanges,
} from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { IsavValidators } from '../../../utils/forms/validators';
import { EventDto } from '../../../core/dto/event';

@Component({
    selector: 'isav-events-form',
    templateUrl: './events-form.html',
    styleUrls: ['./events-form.sass'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventsForm implements OnChanges {
    @Input() value: EventDto;
    @Output() save = new EventEmitter<EventDto>();
    @Output() remove = new EventEmitter<void>();
    @Output() publish = new EventEmitter<EventDto>();
    @Output() unpublish = new EventEmitter<void>();

    form = new UntypedFormGroup({
        title: new UntypedFormControl(null, IsavValidators.required('Title is required')),
        topics: new UntypedFormControl(null),
        startEndDates: new UntypedFormControl(null),
        location: new UntypedFormControl(null),
        activity: new UntypedFormControl(null),
        attachments: new UntypedFormControl(null),
        contactName: new UntypedFormControl(null),
        contactEmail: new UntypedFormControl(null),
        contactPhone: new UntypedFormControl(null),
        coverImage: new UntypedFormControl(null),
        description: new UntypedFormControl(null),
    });

    ngOnChanges(changes: SimpleChanges) {
        if (changes.value && this.value) {
            this.form.reset(this.value);
        }
    }

    isDisabled() {
        if (!this.form.value.startEndDates.length) return !this.form.valid;
        return !this.form.get('startEndDates')!.valid || !this.form.valid;
    }

    onSave() {
        this.save.emit({
            ...this.form.value,
        });
    }

    onDelete() {
        this.remove.emit();
    }

    onPublish() {
        this.publish.emit({
            ...this.form.value,
        });
    }

    onUnpublish() {
        this.unpublish.emit();
    }
}
